// CDN Base URL for assets
export const CDN_BASE_URL = 'https://cdnsm.swipey.ai/prelander/createsexfriend-white'
export const CDN_URL = 'https://cdnsm.swipey.ai'

// Application Steps
// Order (policy/Meta): style → ethnicity(+age) → hair → voice/relationship → body.
// step2 (body/breast/butt) intentionally comes AFTER step3 (hair) and step4 (voice)
// so the relationship-building attributes lead and the body step is last.
export const QUIZ_STEPS = [
  'welcome',
  'step1',
  'step3',
  'step4',
  'step2',
  'step5',
  'loading',
  'createAccount',
  'login',
]

// /quiz route uses a shorter flow with a custom Choose-your-character step
export const QUIZ_ROUTE_STEPS = [
  'welcome',
  'character',
  'step4',
  'step5',
]



// Steps that should not show progress stepper and not be counted in total
export const HIDDEN_STEPS = [6, 7, 8] // loading, createAccount, login

// Local Storage Keys
export const STORAGE_KEYS = {
  AI_GIRLFRIEND_SELECTIONS: 'aiGirlfriendSelections',
  TRACKING_PARAMS: 'trackingParams',
}

export const getQuizOptionsData = (step, selectedStyle = 'Realistic') => {
  const options = QUIZ_OPTIONS_DATA[step] || []

  if (!selectedStyle || selectedStyle === 'Realistic') return options

  // If anime style is selected, update paths to use Anime folder
  if (selectedStyle === 'Anime') {
    return options.map(item => {
      const updatePath = path => {
        if (!path) return path

        // If already has "/Anime/" — don't change
        if (path.includes('/Anime/')) return path

        // Convert CDN paths to Anime versions
        if (path.startsWith(CDN_BASE_URL)) {
          const fileName = path.split('/').pop()
          return `${CDN_BASE_URL}/Anime/${fileName}`
        }

        // Convert old local asset paths to Anime versions
        const parts = path.split('/assets/')
        if (parts.length > 1) {
          return `${CDN_BASE_URL}/Anime/${parts[1]}`
        }

        return path
      }

      return {
        ...item,
        image: updatePath(item.image),
        leftGirl: updatePath(item.leftGirl),
        rightGirl: updatePath(item.rightGirl),
      }
    })
  }

  return options
}

// Quiz Options Data
export const QUIZ_OPTIONS_DATA = {
  // Step 0 - Welcome (AI Girlfriend Type)
  welcome: [
    {
      value: 'Realistic',
      text: 'realistic',
      image: `${CDN_BASE_URL}/Realistic/step0-image.jpg`,
      alt: 'Realistic AI Girlfriend',
      hasIcon: true,
    },
    {
      value: 'Anime',
      text: 'anime',
      image: `${CDN_BASE_URL}/Anime/step0-image.jpg`,
      alt: 'Anime AI Girlfriend',
      hasIcon: true,
    },
  ],

  // Step 1 - Ethnicity
  ethnicity: [
    {
      leftGirl: `${CDN_BASE_URL}/Realistic/euroLeft.png`,
      rightGirl: `${CDN_BASE_URL}/Realistic/euroRight.png`,
      value: 'Caucasian',
      text: 'ethnicity.caucasian',
      image: `${CDN_BASE_URL}/Realistic/step1-image1.png`,
      alt: 'Caucasian',
      hasIcon: true,
    },
    {
      leftGirl: `${CDN_BASE_URL}/Realistic/asianLeft.png`,
      rightGirl: `${CDN_BASE_URL}/Realistic/asianRight.png`,
      value: 'Asian',
      text: 'ethnicity.asian',
      image: `${CDN_BASE_URL}/Realistic/step1-image2.png`,
      alt: 'Asian',
      hasIcon: true,
    },
    {
      leftGirl: `${CDN_BASE_URL}/Realistic/ArabLeft.png`,
      rightGirl: `${CDN_BASE_URL}/Realistic/ArabRight.png`,
      value: 'Mid.Eastern',
      text: 'ethnicity.arab',
      image: `${CDN_BASE_URL}/Realistic/step1-image3.png`,
      alt: 'Arab',
      hasIcon: true,
    },
    {
      leftGirl: `${CDN_BASE_URL}/Realistic/africanLeft.png`,
      rightGirl: `${CDN_BASE_URL}/Realistic/africanRight.png`,
      value: 'African',
      text: 'ethnicity.african',
      image: `${CDN_BASE_URL}/Realistic/step1-image4.png`,
      alt: 'African',
      hasIcon: true,
    },
    {
      leftGirl: `${CDN_BASE_URL}/Realistic/latinaLeft.png`,
      rightGirl: `${CDN_BASE_URL}/Realistic/latinaRight.png`,
      value: 'Latina',
      text: 'ethnicity.latina',
      image: `${CDN_BASE_URL}/Realistic/step1-image5.png`,
      alt: 'Latina',
      hasIcon: true,
    },
  ],

  // Step 2 - Body Type
  bodyType: [
    {
      value: 'Slim',
      text: 'bodyType.slim',
      image: `${CDN_BASE_URL}/Realistic/step2-body1.png`,
      alt: 'Slim body type',
      hasIcon: true,
    },
    {
      value: 'Athletic',
      text: 'bodyType.athletic',
      image: `${CDN_BASE_URL}/Realistic/step2-body2.png`,
      alt: 'Athletic body type',
      hasIcon: true,
    },
    {
      value: 'Average',
      text: 'bodyType.average',
      image: `${CDN_BASE_URL}/Realistic/step2-body3.png`,
      alt: 'Average body type',
      hasIcon: true,
    },
    {
      value: 'Voluptuous',
      text: 'bodyType.curvy',
      image: `${CDN_BASE_URL}/Realistic/step2-body4.png`,
      alt: 'Curvy body type',
      hasIcon: true,
    },
  ],

  // Step 2 - Breast Size
  breastSize: [
    {
      value: 'Small (B)',
      text: 'breastSize.small',
      image: `${CDN_BASE_URL}/Realistic/step2-breast1.png`,
      alt: 'Small breast size',
      hasIcon: true,
    },
    {
      value: 'Medium (C)',
      text: 'breastSize.medium',
      image: `${CDN_BASE_URL}/Realistic/step2-breast2.png`,
      alt: 'Medium breast size',
      hasIcon: true,
    },
    {
      value: 'Large (D)',
      text: 'breastSize.large',
      image: `${CDN_BASE_URL}/Realistic/step2-breast3.png`,
      alt: 'Large breast size',
      hasIcon: true,
    },
    {
      value: 'Huge (DD)',
      text: 'breastSize.huge',
      image: `${CDN_BASE_URL}/Realistic/step2-breast4.png`,
      alt: 'Huge breast size',
      hasIcon: true,
    },
  ],

  // Step 2 - Butt Size
  buttSize: [
    {
      value: 'Small',
      text: 'buttSize.small',
      image: `${CDN_BASE_URL}/Realistic/step2-booty1.png`,
      alt: 'Small butt size',
      hasIcon: true,
    },
    {
      value: 'Medium',
      text: 'buttSize.medium',
      image: `${CDN_BASE_URL}/Realistic/step2-booty2.png`,
      alt: 'Medium butt size',
      hasIcon: true,
    },
    {
      value: 'Athletic',
      text: 'buttSize.athletic',
      image: `${CDN_BASE_URL}/Realistic/step2-booty3.png`,
      alt: 'Athletic butt size',
      hasIcon: true,
    },
    {
      value: 'Large',
      text: 'buttSize.large',
      image: `${CDN_BASE_URL}/Realistic/step2-booty4.png`,
      alt: 'Large butt size',
      hasIcon: true,
    },
  ],

  // Step 3 - Hair Color
  hairColor: [
    // {
    //   value: 'Black',
    //   text: 'hairColor.black',
    //   image: `${CDN_BASE_URL}/Realistic/step3-hair3.png`,
    //   alt: 'Black hair',
    //   hasIcon: true,
    // },
    {
      value: 'Brown',
      text: 'hairColor.brunette',
      image: `${CDN_BASE_URL}/Realistic/step3-hair2.png`,
      alt: 'Brunette hair',
      hasIcon: true,
    },
    {
      value: 'Blonde',
      text: 'hairColor.blonde',
      image: `${CDN_BASE_URL}/Realistic/step3-hair1.png`,
      alt: 'Blonde hair',
      hasIcon: true,
    },
    // {
    //   value: 'Pink',
    //   text: 'hairColor.pink',
    //   image: `${CDN_BASE_URL}/Realistic/step3-hair4.png`,
    //   alt: 'Pink hair',
    //   hasIcon: true,
    // },
    {
      value: 'Red',
      text: 'hairColor.redhead',
      image: `${CDN_BASE_URL}/Realistic/step3-hair5.png`,
      alt: 'Redhead hair',
      hasIcon: true,
    },
  ],

  // Step 3 - Hair Style
  hairStyle: [
    {
      value: 'Straight',
      text: 'hairStyle.straight',
      image: `${CDN_BASE_URL}/Realistic/step3-hairstyle1.png`,
      alt: 'Straight hair style',
      hasIcon: true,
    },
    // {
    //   value: 'Wavy',
    //   text: 'hairStyle.wavy',
    //   image: `${CDN_BASE_URL}/Realistic/step3-hairstyle2.png`,
    //   alt: 'Wavy hair style',
    //   hasIcon: true,
    // },
    // {
    //   value: 'Braids',
    //   text: 'hairStyle.braids',
    //   image: `${CDN_BASE_URL}/Realistic/step3-hairstyle3.png`,
    //   alt: 'Braids hair style',
    //   hasIcon: true,
    // },
    {
      value: 'Bun',
      text: 'hairStyle.bun',
      image: `${CDN_BASE_URL}/Realistic/step3-hairstyle4.png`,
      alt: 'Bun hair style',
      hasIcon: true,
    },
    // {
    //   value: 'Curly',
    //   text: 'hairStyle.curly',
    //   image: `${CDN_BASE_URL}/Realistic/step3-hairstyle5.png`,
    //   alt: 'Curly hair style',
    //   hasIcon: true,
    // },
    {
      value: 'Ponytail',
      text: 'hairStyle.ponytail',
      image: `${CDN_BASE_URL}/Realistic/step3-hairstyle6.png`,
      alt: 'Ponytail hair style',
      hasIcon: true,
    },
  ],

  // Step 3 - Eye Color
  eyeColor: [
    {
      value: 'Brown',
      text: 'eyeColor.brown',
      image: `${CDN_BASE_URL}/Realistic/step3-eye2.png`,
      alt: 'Brown eyes',
      hasIcon: true,
    },
    {
      value: 'Blue',
      text: 'eyeColor.blue',
      image: `${CDN_BASE_URL}/Realistic/step3-eye1.png`,
      alt: 'Blue eyes',
      hasIcon: true,
    },
    {
      value: 'Green',
      text: 'eyeColor.green',
      image: `${CDN_BASE_URL}/Realistic/step3-eye3.png`,
      alt: 'Green eyes',
      hasIcon: true,
    },
  ],

  // /quiz route — Choose your character (5 cards, replaces Step1+Step2+Step3)
  character: [
    {
      value: 'goth',
      text: 'Goth',
      alt: 'Goth',
      hasIcon: true,
    },
    {
      value: 'muse',
      text: 'Muse',
      alt: 'Muse',
      hasIcon: true,
    },
    {
      value: 'nerd',
      text: 'Nerd',
      alt: 'Nerd',
      hasIcon: true,
    },
    {
      value: 'princess',
      text: 'Princess',
      alt: 'Princess',
      hasIcon: true,
    },
    {
      value: 'star',
      text: 'Star',
      alt: 'Star',
      hasIcon: true,
    },
  ],

  // Step 4 - Voice
  voice: [
    {
      value: 'Voice 3',
      text: 'voice.teen',
      icon: '😋',
      audio: `${CDN_BASE_URL}/sounds/voice2.mp3`,
      hasIcon: true,
    },
    {
      value: 'Voice 4',
      text: 'voice.soft',
      icon: '😌',
      audio: `${CDN_BASE_URL}/sounds/voice3.mp3`,
      hasIcon: true,
    },
    {
      value: 'Voice 5',
      text: 'voice.mature',
      icon: '😈',
      audio: `${CDN_BASE_URL}/sounds/voice4.mp3`,
      hasIcon: true,
    },
  ],

  // Step 4 - Relationships
  personality: [
    {
      value: 'stepSis',
      text: 'personality.stepSis',
      icon: 'stepSis',
      description: 'Close family bond',
      hasIcon: true,
    },
    {
      value: 'stepMom',
      text: 'personality.stepMom',
      icon: 'stepMom',
      description: 'Caring and nurturing',
      hasIcon: true,
    },
    {
      value: 'girlfriend',
      text: 'personality.girlfriend',
      icon: 'girlfriend',
      description: 'Romantic and caring',
      hasIcon: true,
    },
  ],

  // Legacy steps for backward compatibility
  age: [
    { value: '18-24', text: '18-24' },
    { value: '25-35', text: '25-34' },
    { value: '35-44', text: '35-44' },
    { value: '45+', text: '45+' },
  ],

  useAI: [
    {
      value: '1',
      text: 'I use ChatGPT to help with simple tasks',
      image: '/assets/1.webp',
      alt: 'ChatGPT user',
      hasIcon: true,
    },
    {
      value: '2',
      text: 'I actively explore AI including image and video generation',
      image: '/assets/2.webp',
      alt: 'AI explorer',
      hasIcon: true,
    },
    {
      value: '3',
      text: 'I experiment with AI tools, can write prompts and use it for coding',
      image: '/assets/3.webp',
      alt: 'AI experimenter',
      hasIcon: true,
      defaultChecked: true,
    },
    {
      value: '4',
      text: 'I have no experience with AI',
      image: '/assets/4.webp',
      alt: 'AI beginner',
      hasIcon: true,
    },
  ],

  friendAI: [
    { value: '1', text: 'Having fun' },
    { value: '2', text: 'Staying motivated and focused' },
    { value: '3', text: 'Learning new skills' },
    { value: '4', text: 'Emotional support and advice' },
    { value: '5', text: 'Creative ideas and brainstorming' },
  ],
}

// CSS Variables
export const CSS_VARIABLES = {
  // Colors
  colors: {
    primary: '#8350cb',
    secondary: '#fe6283',
    pinkAccent: '#FE6283',
    white: '#ffffff',
    semiTransparentWhite: 'rgba(255, 255, 255, 0.1)',
    background: '#271a2b',
  },

  // Spacing
  spacing: {
    xs: '8px',
    s: '12px',
    m: '16px',
    l: '24px',
    xl: '32px',
    xxl: '48px',
  },

  // Border radius
  borderRadius: {
    s: '8px',
    m: '12px',
    l: '16px',
  },

  // Transitions
  transitions: {
    normal: '0.3s ease',
    fast: '0.15s ease',
  },

  // Shadows
  shadows: {
    s: '0 2px 8px rgba(0, 0, 0, 0.1)',
    m: '0 4px 16px rgba(0, 0, 0, 0.15)',
    l: '0 8px 32px rgba(0, 0, 0, 0.2)',
  },

  // Font sizes
  fontSizes: {
    xs: '12px',
    s: '14px',
    m: '16px',
    l: '18px',
    xl: '24px',
    xxl: '36px',
  },
}

// Audio files mapping
export const AUDIO_FILES = {
  voice1: '/assets/sounds/voice1.mp3',
  voice2: '/assets/sounds/voice2.mp3',
  voice3: '/assets/sounds/voice3.mp3',
  voice4: '/assets/sounds/voice4.mp3',
}

// Personality icons mapping
export const PERSONALITY_ICONS = {
  stepSis: '🧸',
  stepMom: '💝',
  girlfriend: '💕',
  sexFriend: '👥',
}

// Personality titles mapping
export const PERSONALITY_TITLES = {
  stepSis: 'personality.stepSis',
  stepMom: 'personality.stepMom',
  girlfriend: 'personality.girlfriend',
  sexFriend: 'personality.sexFriend',
}

export const growthBookInstances = {
  'realistic-home-video':
    'prelander/createsexfriend/Realistic/realistic_createsexfriend_2.mp4',
  'realistic-home-poster':
    'prelander/createsexfriend/Realistic/step0-image.jpg',
  'anime-home-poster': 'prelander/createsexfriend/Anime/step0-image.jpg',
  'anime-home-video':
    'prelander/createsexfriend/Anime/anime_createsexfriend.mp4',
  'realistic-auth-video':
    'prelander/createsexfriend/Realistic/auth_realistic.mp4',
  'realistic-auth-photo':
    'prelander/createsexfriend/Realistic/first_frame_realistic.jpg',
  'anime-auth-video': 'prelander/createsexfriend/Anime/auth_anime.mp4',
  'anime-auth-photo': 'prelander/createsexfriend/Anime/first_frame_anime.jpg',
  'realistic-auth-video2':
    'prelander/createsexfriend/Realistic/auth_realistic_2.mp4',
  'realistic-auth-photo2':
    'prelander/createsexfriend/Realistic/first_frame_realistic_2.jpg',
  'anime-auth-video2': 'prelander/createsexfriend/Anime/auth_anime_2.mp4',
  'anime-auth-photo2':
    'prelander/createsexfriend/Anime/first_frame_anime_2.jpg',
}
